import { z } from 'zod';
import { environment } from './util.environment.js';
import { makeEnvironmentRef } from './util.make-environment-ref.js';

function asArray(key, options) {
  return makeEnvironmentRef(
    () => z.preprocess(
      (input) => !input ? [] : Array.isArray(input) ? input : input.split((options == null ? void 0 : options.delimiter) ?? ";"),
      z.array((options == null ? void 0 : options.itemSchema) ?? z.string())
    ).parse(environment.read(key, options))
  );
}

export { asArray };
//# sourceMappingURL=parser.array.js.map
